<template>
    <div>
        <loading :active.sync="loadingContent" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Transfer Saldo</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <div class="section full mt-2">
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item pt-2 pb-2 pl-3 pr-3">
                            <div class="in">
                                <div>Saldo saat ini</div>
                                <span class="text-primary">Rp {{ customer.balance | rupiah }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <div class="form-group basic">
                        <label class="label">Nomor Handphone Penerima</label>
                        <input type="number" class="form-control form-control-lg" v-model="data.phone">
                        <div class="input-info">Contoh : 081234567890</div>
                    </div>
                    <div class="form-group basic">
                        <label class="label">Nominal Saldo</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><small>Rp</small></span>
                            </div>
                            <input type="tel" class="form-control form-control-lg" v-model="data.nominal" oninput="this.value = this.value.replace(/[^0-9]/g, '')" @input="inputNominal()">
                        </div>
                    </div>
                    <div class="form-group basic">
                        <button v-for="item in nominal" :key="item" class="btn btn-outline-primary btn-sm mr-1 mb-1" style="border-radius:50px;" @click="inputNominal(item)">Rp {{ item | rupiah }}</button>
                    </div>
                    <div class="form-group basic">
                        <ButtonLoader :loading="loading.check" :styled="'btn btn-primary btn-block btn-lg'" @click.native="check_receiver()">Lanjutkan</ButtonLoader>
                    </div>
                </div>
            </div>
        </div>

        <action-sheet ref="confirm" :title="'Konfirmasi Transfer'" :inset="true">
            <div class="mb-2">
                <small>Kamu yakin akan melakukan transfer saldo ke</small>
                <h2 class="text-uppercase mb-0">{{ data.name }}</h2>
                <span>{{ data.phone }}</span>
            </div>
            <div>
                <small>Nominal Transfer</small>
                <h1><small style="font-size:15px;">Rp</small> {{ data.nominal | rupiah }}</h1>
            </div>
            <div class="form-group boxed" v-if="customer.pin_trx == 'ENABLED'">
                <label class="label text-center">Masukkan PIN</label>
                <input type="number" pattern="[0-9]*" inputmode="numeric" class="form-control form-control-lg text-center p-0 input-password" style="letter-spacing: 0.7em" maxlength="6" v-model="data.pin" oninput="this.value = this.value.replace(/[^0-9]/g, '')">
            </div>
            <div class="form-group basic">
                <ButtonLoader :loading="loading.button" :styled="'btn btn-primary btn-block btn-lg'" @click.native="submit()">Transfer</ButtonLoader>
            </div>
        </action-sheet>

        <action-sheet ref="status" :title="'Transfer Saldo'" :inset="true"> 
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Berhasil diproses</h3>
                <p>Transfer saldo Anda berhasil diproses</p>
            </div>
            <div class="form-group basic">
                <button class="btn btn-primary btn-block btn-lg" @click="action_sheet_status('hide')">Tutup</button>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../api.js'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            loadingContent: false,
            loading: {
                button: false,
                check: false
            },
            nominal: [10000,50000,100000, 500000, 1000000, 2000000],
            data: {
                phone: '',
                name: '',
                nominal: '',
                pin: ''
            }
        }
    },
    created(){
        this.loadingContent = true
        setTimeout(() => this.loadingContent = false, 500)
    },
    computed: {
        ...mapState(['toast','customer'])
    },
    methods:{
        ...mapActions(['getCustomer']),
        inputNominal(nominal){
            this.$store.commit('RESET_TOAST')
            if(this.data.nominal == ''){
                this.data.nominal = '0'
            }
            if(nominal == undefined){
                const nominal_request = parseInt(this.data.nominal)
                this.data.nominal = this.$options.filters.inputRupiah(nominal_request.toString())
            }else{
                const nominal_request = parseInt(this.data.nominal.replace(/[^,\d]/g,'')) + nominal
                this.data.nominal = this.$options.filters.inputRupiah(nominal_request.toString())
            }
        },
        clear_data(){
            this.$store.commit('RESET_TOAST')
            this.data = {
                phone: '',
                name: '',
                nominal: '',
                pin: ''
            }
        },
        check_receiver(){
            this.$store.commit('RESET_TOAST')
            this.data.nominal = this.data.nominal.replace(/[^,\d]/g, '');
            this.loading.check = true
            $axios.post('/transfer/check', this.data)
            .then((response) => {
                this.data.name = response.data.data.name
                this.loading.check = false
                this.action_sheet_confirm('show')     
            }).catch((e) => {
                this.loading.check = false
                this.action_sheet_confirm('hide')
                this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default',icon:'danger'})
            })
            
        },
        action_sheet_confirm(value){
            this.data.pin = ''
            let element = this.$refs.confirm.$el
            window.$(element).modal(value)
        },
        action_sheet_status(value){
            let element = this.$refs.status.$el
            window.$(element).modal(value)
        },
        submit(){
            this.loading.button = true
            $axios.post('/transfer', this.data)
            .then(() => {
                this.getCustomer()
                this.loading.button = false
                this.data.phone = ''
                this.clear_data()
                this.action_sheet_confirm('hide')
                this.action_sheet_status('show')
            }).catch(e => {
                this.loading.button = false
                this.action_sheet_confirm('hide')
                this.$store.commit('SET_TOAST', {show:true,message:e.response.data.message,tipe:'default',icon:'danger'})
            })
        },
        openPhoneBook(){
            if (typeof window.AndroidNative !== 'undefined') {
                window.AndroidNative.openPhoneBook();
            }
        },
    },
    destroyed() {
        this.$store.commit('RESET_TOAST')
    },
    filters:{
        inputRupiah: function(value){
            var number_string = value.replace(/[^,\d]/g, '').toString(),
            split   		= number_string.split(','),
            sisa     		= split[0].length % 3,
            rupiah     		= split[0].substr(0, sisa),
            ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }

            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            return rupiah
        },
    }
    
}
</script>